<template lang="pug">
  .google-translate-widget(id="google_translate_element" :class="{ isHidden: !languageTranslatorOn }")
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "GoogleTranslator",

  data() {
    return {
      googleTranslateWidgetOn: false
    };
  },

  computed: {
    ...mapGetters("program", ["coreProgramMeta"]),

    isLoggedIn() {
      return this.$auth.check();
    },

    languageTranslatorOn() {
      if (this.isLoggedIn) {
        return this._.get(this.coreProgramMeta, "languageTranslator", false);
      }
      return false;
    }
  }
};
</script>

<style scoped lang="sass">
.isHidden
  visibility: hidden
.translate-style-content
  padding-top: 37px
.google-translate-widget
  width: 100%
  background-image: url(https://translate.googleapis.com/translate_static/img/te_bk.gif)
  height: 37px
  z-index: 10000
  position: fixed
  top: 0
  left: 0
  /deep/ .goog-te-gadget-simple
    height: 37px
    width: 200px
    text-align: center
    box-sizing: border-box
    padding-top: 7px
    background-image: url(https://translate.googleapis.com/translate_static/img/te_bk.gif)
</style>
